/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_DiffInputs */

const en_sidebar_diff = /** @type {(inputs: Sidebar_DiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON Diff`)
};

const ko_sidebar_diff = /** @type {(inputs: Sidebar_DiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 비교`)
};

const ja_sidebar_diff = /** @type {(inputs: Sidebar_DiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON比較`)
};

/**
* | output |
* | --- |
* | "JSON Diff" |
*
* @param {Sidebar_DiffInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_diff = /** @type {((inputs?: Sidebar_DiffInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_DiffInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_diff(inputs)
	if (locale === "ko") return ko_sidebar_diff(inputs)
	return ja_sidebar_diff(inputs)
});